import React from "react";
import AgentCard from "./AgentCard";

export default function AgentList({ agents }) {
  if (agents.length === 0) {
    return (
      <div className="empty-state">
        <p>No agents found.</p>
      </div>
    );
  }

  return (
    <div className="agent-grid">
      {agents.map((agent) => (
        <AgentCard key={agent.agent_id} agent={agent} />
      ))}
    </div>
  );
}
